import { makeAutoObservable } from 'mobx';
import * as accountService from '@/services/account';

export class Application {
  menuCollapsed = false;
  loading = false;
  user = null;
  account = {};
  pagination = {};
  account_flow = [];

  constructor() {
    makeAutoObservable(this);
  }

  updateMenuCollapsed(val) {
    this.menuCollapsed = val;
  }

  updateLoading(val) {
    this.loading = val;
  }

  async getAsyncInfo() {
    const res = await new Promise((resolve) => {
      setTimeout(() => {
        resolve({ code: 0, data: {} });
      }, 1000);
    });
    return res;
  }

  async getUserInfo() {
    const res = await accountService.getUserInfo();
    if (res.code === 0) {
      this.user = res.data.user;
    }
    return res;
  }

  userRegister(params) {
    return accountService.userRegister(params);
  }

  getRegisterCode(params) {
    return accountService.getRegisterCode(params);
  }
  userLogin(params) {
    return accountService.userLogin(params);
  }
  withdraw(params) {
    return accountService.withdraw(params);
  }

  userLogout(params) {
    return accountService.userLogout(params);
  }

  userForget(params) {
    return accountService.userForget(params);
  }

  getForgetCode(params) {
    return accountService.getForgetCode(params);
  }

  async getAccountInfo(params) {
    const res = await accountService.getAccountInfo(params);
    if (res.code === 0) {
      this.account = res.data.account;
    }
    return res;
  }

  async getAccountFlow(params) {
    const res = await accountService.getAccountFlow(params);
    if (res.code === 0) {
      this.account_flow = res.data.flows;
      this.pagination = res.data.pagination;
    }
    return res;
  }
}

export const APPLICATION = 'application';
